// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import RichText from '/react4xp/components/RichText'
import Counter from '/react4xp/components/Counter'

// css
import './index.scss'

// types
export interface StatisticsCardProps {
    className?: string
    isAnimated?: boolean
    color?: 'green' | 'beige' | 'green-light'
    invert?: boolean
    text?: string,
    statistics?: {
        value?: number
        abbreviation?: string
        description?: string
    }[]
    source?: {
        text?: string
        hrefText?: string
        href?: string
        external?: boolean
    }
}

export default function StatisticsCard({
    className,
    isAnimated,
    color,
    invert,
    text,
    statistics,
    source
}: StatisticsCardProps) {
    return (
        <Section className={clsx('statistics-component', className)}>
            <div className='container'>
                <div className='row'>

                    <div
                        className={clsx(
                            'col-lg-6',
                            invert && 'col-lg-push-6'
                        )}
                        data-stagger-up={isAnimated ? 'true' : 'false'}
                    >
                        {text && (
                            <RoundedBox bgColor={color}>
                                <div className='statistics-component__box-wrapper'>
                                    <RichText>
                                        {text}
                                    </RichText>
                                </div>
                            </RoundedBox>
                        )}
                    </div>

                    <div className={clsx(
                        'col-lg-6',
                        invert && 'col-lg-pull-6'
                    )}>
                        <div className='statistics-component__statistics-wrapper'>

                            <div className='numbers'>
                                {statistics?.map((item, i) => (
                                    <div
                                        className='numbers__item'
                                        key={i}
                                    >
                                        
                                        <div className='numbers__number'>
                                            <h3 className='h1'>
                                                <Counter number={item.value || 0} /> {item.abbreviation}
                                            </h3>
                                        </div>

                                        <p className='body'>
                                            {item.description}
                                        </p>

                                    </div>
                                ))}
                            </div>

                            {source && (
                                <div className="statistics-component__source body-small">
                                    <span>{source.text}: </span>
                                    <a
                                        className='simple-link'
                                        style={{marginLeft: '0.125rem'}}
                                        href={source.href}
                                        target={source.external ? '_blank' : undefined}
                                        rel={source.external ? 'noopener noreferrer' : undefined}
                                    >
                                        {source.hrefText}
                                    </a>
                                </div>
                            )}

                        </div>
                    </div>

                </div>
            </div>
        </Section>
    )
}